//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { crudTestSendApi, crudAddCurlApi, crudGetCurlEditApi, crudPutCurlApi } from '@/api/develop';
export default {
  name: '',
  props: {},
  data: function data() {
    return {
      drawer: false,
      loading: false,
      id: 0,
      form: {
        title: '',
        url: '',
        is_pre: '1',
        method: 'get',
        headers: [{
          name: '',
          type: '0',
          value: ''
        }],
        data: [{
          name: '',
          type: '0',
          value: ''
        }],
        pre_method: 'get',
        pre_url: '',
        pre_headers: [{
          name: '',
          value: ''
        }],
        pre_data: [{
          name: '',
          value: ''
        }],
        pre_cache_time: ''
      },
      requestMethod: [{
        value: 'get',
        label: 'get'
      }, {
        value: 'post',
        label: 'post'
      }, {
        value: 'put',
        label: 'put'
      }, {
        value: 'delete',
        label: 'delete'
      }],
      rules: {
        title: [{
          required: true,
          message: '请输入接口标题',
          trigger: 'blur'
        }],
        is_pre: [{
          required: true,
          message: '请选择请求类型',
          trigger: 'blur'
        }],
        url: [{
          required: true,
          message: '请输入链接地址',
          trigger: 'blur'
        }],
        method: [{
          required: true,
          message: '请选择请求方式',
          trigger: 'blur'
        }],
        pre_method: [{
          required: true,
          message: '请选择请求方式',
          trigger: 'blur'
        }],
        pre_url: [{
          required: true,
          message: '请输入地址',
          trigger: 'blur'
        }]
      },
      fieldValue: [],
      options: [{
        value: '0',
        label: '固定值'
      }, {
        value: '1',
        label: '响应值'
      }]
    };
  },
  methods: {
    openBox: function openBox(id) {
      if (id) {
        this.id = id;
        this.getInfo(id);
      }
      this.drawer = true;
    },
    addFn: function addFn(val, type) {
      if (type === 'pre') {
        this.form[val].push({
          name: '',
          type: '0',
          value: ''
        });
      } else {
        this.form[val].push({
          name: '',
          value: ''
        });
      }
    },
    // 测试请求
    requestFn: function requestFn() {
      var _this = this;
      var data = {
        url: this.form.pre_url,
        method: this.form.pre_method,
        headers: this.form.pre_headers,
        data: this.form.pre_data
      };
      this.fieldValue = [];
      crudTestSendApi(data).then(function (res) {
        if (res.status == 200) {
          var key = res.data.key;
          key.map(function (item) {
            var obj = {
              label: item,
              value: item
            };
            _this.fieldValue.push(obj);
          });
        }
      });
    },
    deleteFn: function deleteFn(val, index) {
      this.form[val].splice(index, 1);
    },
    getInfo: function getInfo(id) {
      var _this2 = this;
      crudGetCurlEditApi(id).then(function (res) {
        for (var key in res.data) {
          _this2.form[key] = res.data[key];
        }
        _this2.form.is_pre = _this2.form.is_pre + '';
      });
    },
    handleConfirm: function handleConfirm() {
      var _this3 = this;
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          _this3.loading = true;
          if (_this3.id > 0) {
            crudPutCurlApi(_this3.id, _this3.form).then(function (res) {
              if (res.status == 200) {
                _this3.handleClose();
                _this3.$emit('getList');
              }
              _this3.loading = false;
            });
          } else {
            crudAddCurlApi(_this3.form).then(function (res) {
              if (res.status == 200) {
                _this3.handleClose();
                _this3.$emit('getList');
              }
              _this3.loading = false;
            });
          }
        }
      });
    },
    handleClose: function handleClose() {
      this.$refs.ruleForm.resetFields();
      this.id = 0;
      this.drawer = false;
      this.form.headers = [{
        name: '',
        type: '0',
        value: ''
      }];
      this.form.data = [{
        name: '',
        type: '0',
        value: ''
      }];
      this.form.pre_headers = [{
        name: '',
        value: ''
      }];
      this.form.pre_data = [{
        name: '',
        value: ''
      }];
    }
  }
};